import * as i0 from '@angular/core';
import { EventEmitter, Component, ViewEncapsulation, Input, Output, ContentChildren, NgModule } from '@angular/core';
import * as i2 from '@angular/common';
import { CommonModule } from '@angular/common';
import { SvgIcons } from '@niceltd/cxone-components/shared-services';
import { trigger, state, style, transition, animate } from '@angular/animations';
import * as i1 from '@angular/platform-browser';
import { SvgSpriteIconModule } from '@niceltd/cxone-components/svg-sprite-icon';
function AccordionTabComponent_div_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 5);
    i0.ɵɵprojection(1, 1);
    i0.ɵɵelementEnd();
  }
}
function AccordionTabComponent_div_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 5);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r1.header);
  }
}
const _c0 = ["*", [["cxone-accordion-custom-header"]]];
const _c1 = (a0, a1) => ({
  "disabled": a0,
  "selected": a1
});
const _c2 = a0 => ({
  transitionParams: a0,
  height: "*"
});
const _c3 = a1 => ({
  value: "visible",
  params: a1
});
const _c4 = a0 => ({
  transitionParams: a0,
  height: "0",
  border: "0"
});
const _c5 = a1 => ({
  value: "hidden",
  params: a1
});
const _c6 = ["*", "cxone-accordion-custom-header"];
const _c7 = ["*"];
const _c8 = ".cxone-accordion{border-left:1px solid rgb(218,226,232);border-right:1px solid rgb(218,226,232);border-top:1px solid rgb(218,226,232)}.cxone-accordion .cxone-accordion-tab{width:100%;font-family:OpenSans}.cxone-accordion .cxone-accordion-tab.disabled{pointer-events:none}.cxone-accordion .cxone-accordion-tab.disabled .tab-header{background-color:#f8f8f8}.cxone-accordion .cxone-accordion-tab.disabled .tab-header .header{color:#707e8d;opacity:.7}.cxone-accordion .cxone-accordion-tab.disabled svg .a{fill:#c3c5c7}.cxone-accordion .cxone-accordion-tab.selected .tab-body{border-bottom:1px solid rgb(218,226,232)}.cxone-accordion .cxone-accordion-tab.selected .icon{transform:rotate(180deg);transition:.2s}.cxone-accordion .cxone-accordion-tab .tab-header{display:flex;align-items:center;padding:0 15px;height:40px;border-bottom:1px solid rgb(218,226,232);overflow:hidden;white-space:nowrap;background-color:#f7f9fa;cursor:pointer;-webkit-user-select:none;user-select:none;transition:.5s}.cxone-accordion .cxone-accordion-tab .tab-header:hover .icon svg .a{fill:#007cbe!important}.cxone-accordion .cxone-accordion-tab .tab-header:active .icon svg .a{fill:#1c639c!important}.cxone-accordion .cxone-accordion-tab .tab-header .header{flex:1;font-size:12px;font-weight:600;font-style:normal;color:#5b7c8c;text-transform:uppercase}.cxone-accordion .cxone-accordion-tab .tab-header .icon{position:relative;transition:.2s}.cxone-accordion .cxone-accordion-tab .tab-header .icon svg{position:relative;top:2px;fill:#adadad;width:13px;height:13px;pointer-events:none}.cxone-accordion .cxone-accordion-tab .tab-body{background-color:#fff;overflow:hidden;position:relative}\n";
class AccordionTabComponent {
  constructor(sanitizer) {
    this.sanitizer = sanitizer;
    /* Determines if the tab is expanded or collapsed */
    this.selected = false;
    /* Determines if the complete header section of the accordion is to be content projected or not */
    this.customHeader = false;
    /* This is the callback which is executed whenever a tab is toggled */
    this.toggle = new EventEmitter();
    /* object which provides methods to fetch svg icons */
    this.svgIcons = new SvgIcons(this.sanitizer);
    /* Default transition animation options for the toggle behavior of the tab */
    this.transitionOptions = '200ms cubic-bezier(0.86, 0, 0.07, 1)';
  }
  ngOnInit() {
    if (this.selected === undefined) {
      this.selected = false;
    }
  }
  /* Method which is executed whenever a tab header is clicked */
  toggleTab(event) {
    if (this.disabled || this.animating) {
      return false;
    }
    this.animating = true;
    this.toggle.emit({
      originalEvent: event,
      isOpen: this.selected,
      tab: this
    });
  }
  /* Method which is executed whenever a toggle animation is complete */
  onToggleDone(_event) {
    this.animating = false;
  }
  /** @nocollapse */
  static {
    this.ɵfac = function AccordionTabComponent_Factory(t) {
      return new (t || AccordionTabComponent)(i0.ɵɵdirectiveInject(i1.DomSanitizer));
    };
  }
  /** @nocollapse */
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: AccordionTabComponent,
      selectors: [["cxone-accordion-tab"]],
      inputs: {
        disabled: "disabled",
        selected: "selected",
        header: "header",
        customHeader: "customHeader"
      },
      outputs: {
        toggle: "toggle"
      },
      ngContentSelectors: _c6,
      decls: 7,
      vars: 16,
      consts: [[1, "cxone-accordion-tab", 3, "ngClass"], ["tabindex", "1", "aria-label", "header", 1, "tab-header", 3, "click", "keydown.enter"], ["class", "header", 4, "ngIf"], [1, "icon", 3, "innerHTML"], [1, "tab-body"], [1, "header"]],
      template: function AccordionTabComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef(_c0);
          i0.ɵɵelementStart(0, "div", 0)(1, "div", 1);
          i0.ɵɵlistener("click", function AccordionTabComponent_Template_div_click_1_listener($event) {
            return ctx.toggleTab($event);
          })("keydown.enter", function AccordionTabComponent_Template_div_keydown_enter_1_listener($event) {
            return ctx.toggleTab($event);
          });
          i0.ɵɵtemplate(2, AccordionTabComponent_div_2_Template, 2, 0, "div", 2)(3, AccordionTabComponent_div_3_Template, 2, 1, "div", 2);
          i0.ɵɵelement(4, "div", 3);
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(5, "div", 4);
          i0.ɵɵlistener("@tabContent.done", function AccordionTabComponent_Template_div_animation_tabContent_done_5_listener($event) {
            return ctx.onToggleDone($event);
          });
          i0.ɵɵprojection(6);
          i0.ɵɵelementEnd()();
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(5, _c1, ctx.disabled, ctx.selected));
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("ngIf", ctx.customHeader);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", !ctx.customHeader);
          i0.ɵɵadvance();
          i0.ɵɵproperty("innerHTML", ctx.svgIcons.getSvgIcons("icon-double-arrow"), i0.ɵɵsanitizeHtml);
          i0.ɵɵadvance();
          i0.ɵɵproperty("@tabContent", ctx.selected ? i0.ɵɵpureFunction1(10, _c3, i0.ɵɵpureFunction1(8, _c2, ctx.animating ? ctx.transitionOptions : "0ms")) : i0.ɵɵpureFunction1(14, _c5, i0.ɵɵpureFunction1(12, _c4, ctx.transitionOptions)));
        }
      },
      dependencies: [i2.NgClass, i2.NgIf],
      styles: [".cxone-accordion{border-left:1px solid rgb(218,226,232);border-right:1px solid rgb(218,226,232);border-top:1px solid rgb(218,226,232)}.cxone-accordion .cxone-accordion-tab{width:100%;font-family:OpenSans}.cxone-accordion .cxone-accordion-tab.disabled{pointer-events:none}.cxone-accordion .cxone-accordion-tab.disabled .tab-header{background-color:#f8f8f8}.cxone-accordion .cxone-accordion-tab.disabled .tab-header .header{color:#707e8d;opacity:.7}.cxone-accordion .cxone-accordion-tab.disabled svg .a{fill:#c3c5c7}.cxone-accordion .cxone-accordion-tab.selected .tab-body{border-bottom:1px solid rgb(218,226,232)}.cxone-accordion .cxone-accordion-tab.selected .icon{transform:rotate(180deg);transition:.2s}.cxone-accordion .cxone-accordion-tab .tab-header{display:flex;align-items:center;padding:0 15px;height:40px;border-bottom:1px solid rgb(218,226,232);overflow:hidden;white-space:nowrap;background-color:#f7f9fa;cursor:pointer;-webkit-user-select:none;user-select:none;transition:.5s}.cxone-accordion .cxone-accordion-tab .tab-header:hover .icon svg .a{fill:#007cbe!important}.cxone-accordion .cxone-accordion-tab .tab-header:active .icon svg .a{fill:#1c639c!important}.cxone-accordion .cxone-accordion-tab .tab-header .header{flex:1;font-size:12px;font-weight:600;font-style:normal;color:#5b7c8c;text-transform:uppercase}.cxone-accordion .cxone-accordion-tab .tab-header .icon{position:relative;transition:.2s}.cxone-accordion .cxone-accordion-tab .tab-header .icon svg{position:relative;top:2px;fill:#adadad;width:13px;height:13px;pointer-events:none}.cxone-accordion .cxone-accordion-tab .tab-body{background-color:#fff;overflow:hidden;position:relative}\n"],
      encapsulation: 2,
      data: {
        animation: [trigger('tabContent', [state('hidden', style({
          height: '0'
        })), state('void', style({
          height: '{{ height }}'
        }), {
          params: {
            height: '0'
          }
        }), state('visible', style({
          height: '*'
        })), transition('visible <=> hidden', animate('{{ transitionParams }}')), transition('void <=> hidden', animate('{{ transitionParams }}')), transition('void <=> visible', animate('{{ transitionParams }}'))])]
      }
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AccordionTabComponent, [{
    type: Component,
    args: [{
      selector: 'cxone-accordion-tab',
      encapsulation: ViewEncapsulation.None,
      animations: [trigger('tabContent', [state('hidden', style({
        height: '0'
      })), state('void', style({
        height: '{{ height }}'
      }), {
        params: {
          height: '0'
        }
      }), state('visible', style({
        height: '*'
      })), transition('visible <=> hidden', animate('{{ transitionParams }}')), transition('void <=> hidden', animate('{{ transitionParams }}')), transition('void <=> visible', animate('{{ transitionParams }}'))])],
      template: "<div class=\"cxone-accordion-tab\" [ngClass]=\"{ 'disabled': disabled, 'selected': selected }\">\n    <div class=\"tab-header\" (click)=\"toggleTab($event)\" tabindex=\"1\" (keydown.enter)=\"toggleTab($event)\" aria-label=\"header\">\n        <div class=\"header\" *ngIf=\"customHeader\">\n            <ng-content select=\"cxone-accordion-custom-header\"></ng-content>\n        </div>\n        <div *ngIf=\"!customHeader\" class=\"header\">{{ header }}</div>\n        <div class=\"icon\" [innerHTML]=\"svgIcons.getSvgIcons('icon-double-arrow')\"></div>\n    </div>\n    <div class=\"tab-body\"\n        [@tabContent]=\"selected ? { value: 'visible', params: { transitionParams: animating ? transitionOptions: '0ms', height: '*'}} : { value: 'hidden', params: { transitionParams: transitionOptions, height: '0', border: '0' }}\"\n        (@tabContent.done)=\"onToggleDone($event)\">\n        <ng-content></ng-content>\n    </div>\n</div>\n",
      styles: [".cxone-accordion{border-left:1px solid rgb(218,226,232);border-right:1px solid rgb(218,226,232);border-top:1px solid rgb(218,226,232)}.cxone-accordion .cxone-accordion-tab{width:100%;font-family:OpenSans}.cxone-accordion .cxone-accordion-tab.disabled{pointer-events:none}.cxone-accordion .cxone-accordion-tab.disabled .tab-header{background-color:#f8f8f8}.cxone-accordion .cxone-accordion-tab.disabled .tab-header .header{color:#707e8d;opacity:.7}.cxone-accordion .cxone-accordion-tab.disabled svg .a{fill:#c3c5c7}.cxone-accordion .cxone-accordion-tab.selected .tab-body{border-bottom:1px solid rgb(218,226,232)}.cxone-accordion .cxone-accordion-tab.selected .icon{transform:rotate(180deg);transition:.2s}.cxone-accordion .cxone-accordion-tab .tab-header{display:flex;align-items:center;padding:0 15px;height:40px;border-bottom:1px solid rgb(218,226,232);overflow:hidden;white-space:nowrap;background-color:#f7f9fa;cursor:pointer;-webkit-user-select:none;user-select:none;transition:.5s}.cxone-accordion .cxone-accordion-tab .tab-header:hover .icon svg .a{fill:#007cbe!important}.cxone-accordion .cxone-accordion-tab .tab-header:active .icon svg .a{fill:#1c639c!important}.cxone-accordion .cxone-accordion-tab .tab-header .header{flex:1;font-size:12px;font-weight:600;font-style:normal;color:#5b7c8c;text-transform:uppercase}.cxone-accordion .cxone-accordion-tab .tab-header .icon{position:relative;transition:.2s}.cxone-accordion .cxone-accordion-tab .tab-header .icon svg{position:relative;top:2px;fill:#adadad;width:13px;height:13px;pointer-events:none}.cxone-accordion .cxone-accordion-tab .tab-body{background-color:#fff;overflow:hidden;position:relative}\n"]
    }]
  }], () => [{
    type: i1.DomSanitizer
  }], {
    disabled: [{
      type: Input
    }],
    selected: [{
      type: Input
    }],
    header: [{
      type: Input
    }],
    customHeader: [{
      type: Input
    }],
    toggle: [{
      type: Output
    }]
  });
})();
class AccordionComponent {
  constructor() {
    /* Determines if multiple tabs can be expanded at a time in the accordion */
    this.multiple = true;
    this.tabs = [];
  }
  ngOnInit() {}
  ngAfterContentInit() {
    this.tabs = this.tabList.toArray();
    this.tabs.forEach(t => {
      t.toggle.subscribe(() => {
        this.openTab(t);
      });
    });
  }
  /* The function which is executed when a tab is toggled */
  openTab(tab) {
    if (!this.multiple) {
      this.tabs.forEach(t => t !== tab ? t.selected = false : tab.selected = !tab.selected);
    } else {
      tab.selected = !tab.selected;
    }
  }
  /** @nocollapse */
  static {
    this.ɵfac = function AccordionComponent_Factory(t) {
      return new (t || AccordionComponent)();
    };
  }
  /** @nocollapse */
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: AccordionComponent,
      selectors: [["cxone-accordion"]],
      contentQueries: function AccordionComponent_ContentQueries(rf, ctx, dirIndex) {
        if (rf & 1) {
          i0.ɵɵcontentQuery(dirIndex, AccordionTabComponent, 4);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.tabList = _t);
        }
      },
      inputs: {
        multiple: "multiple"
      },
      ngContentSelectors: _c7,
      decls: 2,
      vars: 0,
      consts: [[1, "cxone-accordion"]],
      template: function AccordionComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵelementStart(0, "div", 0);
          i0.ɵɵprojection(1);
          i0.ɵɵelementEnd();
        }
      },
      styles: [_c8],
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AccordionComponent, [{
    type: Component,
    args: [{
      selector: 'cxone-accordion',
      encapsulation: ViewEncapsulation.None,
      template: "<div class=\"cxone-accordion\">\n    <ng-content></ng-content>\n</div>",
      styles: [".cxone-accordion{border-left:1px solid rgb(218,226,232);border-right:1px solid rgb(218,226,232);border-top:1px solid rgb(218,226,232)}.cxone-accordion .cxone-accordion-tab{width:100%;font-family:OpenSans}.cxone-accordion .cxone-accordion-tab.disabled{pointer-events:none}.cxone-accordion .cxone-accordion-tab.disabled .tab-header{background-color:#f8f8f8}.cxone-accordion .cxone-accordion-tab.disabled .tab-header .header{color:#707e8d;opacity:.7}.cxone-accordion .cxone-accordion-tab.disabled svg .a{fill:#c3c5c7}.cxone-accordion .cxone-accordion-tab.selected .tab-body{border-bottom:1px solid rgb(218,226,232)}.cxone-accordion .cxone-accordion-tab.selected .icon{transform:rotate(180deg);transition:.2s}.cxone-accordion .cxone-accordion-tab .tab-header{display:flex;align-items:center;padding:0 15px;height:40px;border-bottom:1px solid rgb(218,226,232);overflow:hidden;white-space:nowrap;background-color:#f7f9fa;cursor:pointer;-webkit-user-select:none;user-select:none;transition:.5s}.cxone-accordion .cxone-accordion-tab .tab-header:hover .icon svg .a{fill:#007cbe!important}.cxone-accordion .cxone-accordion-tab .tab-header:active .icon svg .a{fill:#1c639c!important}.cxone-accordion .cxone-accordion-tab .tab-header .header{flex:1;font-size:12px;font-weight:600;font-style:normal;color:#5b7c8c;text-transform:uppercase}.cxone-accordion .cxone-accordion-tab .tab-header .icon{position:relative;transition:.2s}.cxone-accordion .cxone-accordion-tab .tab-header .icon svg{position:relative;top:2px;fill:#adadad;width:13px;height:13px;pointer-events:none}.cxone-accordion .cxone-accordion-tab .tab-body{background-color:#fff;overflow:hidden;position:relative}\n"]
    }]
  }], () => [], {
    multiple: [{
      type: Input
    }],
    tabList: [{
      type: ContentChildren,
      args: [AccordionTabComponent]
    }]
  });
})();
class AccordionCustomHeaderComponent {
  constructor() {}
  ngOnInit() {}
  /** @nocollapse */
  static {
    this.ɵfac = function AccordionCustomHeaderComponent_Factory(t) {
      return new (t || AccordionCustomHeaderComponent)();
    };
  }
  /** @nocollapse */
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: AccordionCustomHeaderComponent,
      selectors: [["cxone-accordion-custom-header"]],
      ngContentSelectors: _c7,
      decls: 1,
      vars: 0,
      template: function AccordionCustomHeaderComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AccordionCustomHeaderComponent, [{
    type: Component,
    args: [{
      selector: 'cxone-accordion-custom-header',
      template: '<ng-content></ng-content>'
    }]
  }], () => [], null);
})();
class AccordionModule {
  /** @nocollapse */static {
    this.ɵfac = function AccordionModule_Factory(t) {
      return new (t || AccordionModule)();
    };
  }
  /** @nocollapse */
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: AccordionModule
    });
  }
  /** @nocollapse */
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [CommonModule, SvgSpriteIconModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AccordionModule, [{
    type: NgModule,
    args: [{
      declarations: [AccordionComponent, AccordionTabComponent, AccordionCustomHeaderComponent],
      imports: [CommonModule, SvgSpriteIconModule],
      exports: [AccordionComponent, AccordionTabComponent, AccordionCustomHeaderComponent]
    }]
  }], null, null);
})();

/**
 * Generated bundle index. Do not edit.
 */

export { AccordionComponent, AccordionCustomHeaderComponent, AccordionModule, AccordionTabComponent };
